import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from '@avla/ui-design';

@Component({
  selector: 'app-modal-policy-privacy',
  templateUrl: './modal-policy-privacy.component.html',
  styleUrls: ['./modal-policy-privacy.component.scss'],
})
export class ModalPolicyPrivacyComponent implements OnInit {
  public modalName: string = 'modal-policy-privacy';

  constructor(private modalService: ModalService) {}

  ngOnInit() {}

  closeModal() {
    this.modalService.close(this.modalName);
  }
}
